import { track } from '@bnnvara/analytics/src/track';
import uniq from 'lodash/uniq';
import { useEffect, useState } from 'react';

import useScrollPosition from './useScrollPosition';

const useSendAnalyticScrollPositions = (elementRef, elementName) => {
  const { percentageY } = useScrollPosition(elementRef);

  const scrollPoints = [100];
  const [passedScrollPoints, setPassedScrollPoints] = useState([]);

  const passedScrollPoint = scrollPoints.reduce((acc, curr) => {
    if (percentageY >= curr) {
      return curr;
    }
    return acc;
  }, 0);

  useEffect(() => {
    // Here we check is percentageY is a number or not, if it's not a number there has been no scroll.
    // We still want to sent data to GA before we start scrolling.
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(percentageY)) {
      track(elementName, 'scroll', '0');
    }

    if (
      passedScrollPoint > 0 &&
      !passedScrollPoints.includes(passedScrollPoint)
    ) {
      const currentPassedScrollPoints = [
        passedScrollPoint,
        ...passedScrollPoints,
      ];

      setPassedScrollPoints(uniq(currentPassedScrollPoints));
      track(elementName, 'scroll', passedScrollPoint.toString());
    }
  }, [passedScrollPoint, passedScrollPoints, elementName, percentageY]);
};

export default useSendAnalyticScrollPositions;
